import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const AddIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon{...props}
                    ref={ref}
            >{'\ue145'}</MuiIcon>
        );
    }
)
